import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isEmpty as _isEmpty } from 'lodash';
import NoticeBox from '@molecules/contents/NoticeBox';
import { Link } from 'react-router-dom';
import { useMobxStores } from '@stores/store';
import NoData from '@atoms/Nodata';

const PartialNoticeBox = ({ data, type }) => {
  const { i18n, t } = useTranslation();

  return (
    <div className="p-3 rounded-[30px] notice_box relative ">
      {!_isEmpty(data) && <NoticeBox data={data} />}

      {_isEmpty(data) && <NoData />}
      <Link
        to={`/${i18n.language}/community/${type}`}
        className="flex items-center justify-center font-bold xs:text-xl text-sm pt-5"
      >
        <img
          src="/img/v2/plus.svg"
          className="w-[15px] xs:w-[20px]  mr-2 inline-block"
        />
        {t('더보기')}
      </Link>
    </div>
  );
};

export default PartialNoticeBox;
